import { Result, failure, success } from '../shared'
import { LoanCalculatorProvider } from './loanCalculator.provider'
import {
  LoanCalculatorServiceErrorCode,
  LoanCalculatorFailure,
  LoanCalculatorSequenceServerData,
  LoanCalculatorLookupsServerData,
  AutoLoanAttributes,
} from './loanCalculator.types'

export class LoanCalculatorService {
  constructor(private provider: LoanCalculatorProvider) {}

  public async sequence(): Promise<Result<LoanCalculatorSequenceServerData, LoanCalculatorFailure>> {
    try {
      const { data } = await this.provider.sequence()
      return success(data)
    } catch (error) {
      return failure(LoanCalculatorServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async lookups(): Promise<Result<LoanCalculatorLookupsServerData, LoanCalculatorFailure>> {
    try {
      const { data } = await this.provider.lookups()
      return success(data)
    } catch (error) {
      return failure(LoanCalculatorServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async auto(attributes: AutoLoanAttributes): Promise<Result<any, LoanCalculatorFailure>> {
    try {
      const { data } = await this.provider.auto(attributes)
      return success(data)
    } catch (error) {
      return failure(LoanCalculatorServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async clear(attributes: any): Promise<Result<any, LoanCalculatorFailure>> {
    try {
      const { data } = await this.provider.clear(attributes)
      return success(data)
    } catch (error) {
      return failure(LoanCalculatorServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async add(attributes: any): Promise<Result<any, LoanCalculatorFailure>> {
    try {
      const { data } = await this.provider.add(attributes)
      return success(data)
    } catch (error) {
      return failure(LoanCalculatorServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async delete(attributes: any): Promise<Result<any, LoanCalculatorFailure>> {
    try {
      const { data } = await this.provider.delete(attributes)
      return success(data)
    } catch (error) {
      return failure(LoanCalculatorServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async print(attributes: any): Promise<Result<any, LoanCalculatorFailure>> {
    try {
      const { data } = await this.provider.print(attributes)
      return success(data)
    } catch (error) {
      return failure(LoanCalculatorServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }
}
